import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as SessionActions from 'web-app/react/entities/sessions/actions';
import * as ProductActions from 'web-app/react/entities/products/actions';
import {replayOnTriggerObservable} from 'web-app/util/epics-helpers';

import * as Actions from './actions';

const listenForUpdates = (action$, state$) => {
    const replayObservable = Observable.combineLatest(
        action$.ofType(SessionActions.fetchAll.type),
        action$.ofType(ProductActions.fetchAll.type),
    );

    const resetObservable = action$.ofType(Actions.showingInstitutionId.type);

    const triggerReplayObservable = Observable.merge(
        action$.ofType(SessionActions.createSuccess.type),
        action$.ofType(SessionActions.updateSuccess.type),
        action$.ofType(SessionActions.restoreSuccess.type),
        action$.ofType(SessionActions.removeSuccess.type),
        action$.ofType(ProductActions.createSuccess.type),
        action$.ofType(ProductActions.updateSuccess.type),
        action$.ofType(ProductActions.restoreSuccess.type),
        action$.ofType(ProductActions.removeSuccess.type),
    );

    const predicate = replayActions =>
        state$.value.plans.planSettings.institutionId === replayActions[0].payload.institutionId;

    return replayOnTriggerObservable(replayObservable, resetObservable, triggerReplayObservable, predicate).catch(
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        () => {},
    );
};

export default combineEpics(listenForUpdates);
